import { render, staticRenderFns } from "./checkbox.component.vue?vue&type=template&id=7022ea5e&scoped=true&"
import script from "./checkbox.component.vue?vue&type=script&lang=js&"
export * from "./checkbox.component.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.component.vue?vue&type=style&index=0&id=7022ea5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7022ea5e",
  null
  
)

export default component.exports